// extracted by mini-css-extract-plugin
export default {"price":"d9-z","onSale":"e9-z","msrpLabelPrice":"f9-z","msrpLabel":"g9-z","originalPrice":"h9-z","percentOff":"i9-z"};